module.exports = __webpack_public_path__ + "img/ICON_Digital-assistance.3fc5b14c.svg";